import * as yup from 'yup'

export class VehicleCheckInImporterDoorLabelPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInImporterDoorLabelPhotoFile?: File = undefined
}

export const vehicleCheckInImporterDoorLabelPhotoValidationSchema = yup.object({
  vehicleCheckInImporterDoorLabelPhotoFile: yup.mixed().notRequired()
})
